import { render } from "./readClubPage.vue?vue&type=template&id=78b994f3&scoped=true"
import script from "./readClubPage.vue?vue&type=script&lang=js"
export * from "./readClubPage.vue?vue&type=script&lang=js"

import "./readClubPage.vue?vue&type=style&index=0&id=78b994f3&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b994f3"]])

export default __exports__